import { AscendError } from "./ascend-error";
export const CommonSystemErrorCodeList = [
    "common.duplicate_resource",
    "common.unhandled",
    "common.unexpected",
    "common.network",
    "common.assertion_failure",
    "common.not_implemented",
];
export class BaseSystemError extends AscendError {
    isSystemError = true;
    constructor(args, e) {
        super({ ...args, type: "system" }, e);
    }
}
class DuplicateResource extends BaseSystemError {
    constructor(message, userMessage, e) {
        super({
            name: "DuplicateResourceError",
            errorCode: "common.duplicate_resource",
            statusCode: 500,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
class Unhandled extends BaseSystemError {
    constructor(message, userMessage, e) {
        super({
            name: "UnhandledError",
            errorCode: "common.unhandled",
            statusCode: 500,
            message: message,
            userMessage: userMessage ??
                "予期せぬエラーが発生しました。時間をおいて、再度お試しください。",
        }, e);
    }
}
class Unexpected extends BaseSystemError {
    constructor(message, userMessage, e) {
        super({
            name: "UnexpectedError",
            errorCode: "common.unexpected",
            statusCode: 500,
            message: message,
            userMessage: userMessage ??
                "予期せぬエラーが発生しました。時間をおいて、再度お試しください。",
        }, e);
    }
}
class Network extends BaseSystemError {
    constructor(message, userMessage, e, statusCode) {
        super({
            name: "UnexpectedError",
            errorCode: "common.network",
            statusCode: (statusCode ?? 500),
            message: message,
            userMessage: userMessage ?? "通信エラーが発生しました。再度お試しください。",
        }, e);
    }
}
class AssertionFailure extends BaseSystemError {
    constructor(message, userMessage, e) {
        super({
            name: "AssertionFailureError",
            errorCode: "common.assertion_failure",
            statusCode: 500,
            message: message,
            userMessage: userMessage ??
                "予期せぬエラーが発生しました。時間をおいて、再度お試しください。",
        }, e);
    }
}
class NotImplemented extends BaseSystemError {
    constructor(message, userMessage, e) {
        super({
            name: "NotImplementedError",
            errorCode: "common.not_implemented",
            statusCode: 500,
            message: message,
            userMessage: userMessage ??
                "予期せぬエラーが発生しました。時間をおいて、再度お試しください。",
        }, e);
    }
}
export const CommonSystemError = {
    DuplicateResource,
    Unhandled,
    Unexpected,
    Network,
    AssertionFailure,
    NotImplemented,
};
export const CommonSystemErrorRegistry = {
    "common.duplicate_resource": DuplicateResource,
    "common.unhandled": Unhandled,
    "common.unexpected": Unexpected,
    "common.network": Network,
    "common.assertion_failure": AssertionFailure,
    "common.not_implemented": NotImplemented,
};
//# sourceMappingURL=system-error.js.map